export default "__VITE_ASSET__yP6DJ$bi__"